module.exports = __webpack_public_path__ + "static/media/NewIngredient2024.12454c8e.png";